// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kv-0";